// Developer tools — the per-instance "Development Mode" capture toggle and the in-process
// "Run Local" / "Local Run" actions — are only meaningful against a non-prod backend, and the
// backend rejects those routes in prod anyway (config.developer_tools_enabled, driven by ENV_LABEL).
// Mirror that on the client off the one env signal the frontend has, REACT_APP_API_URL: show the
// controls only when the API points at staging or a local dev backend, never the prod host.
const apiUrl = process.env.REACT_APP_API_URL ?? "";

export const developerToolsEnabled =
  apiUrl.includes("-staging") ||
  apiUrl.includes("localhost") ||
  apiUrl.includes("127.0.0.1");
